import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Register a default Trusted Types policy to prevent 'TrustedHTML' assignment blocks
if (typeof window !== 'undefined' && (window as any).trustedTypes && (window as any).trustedTypes.createPolicy) {
  try {
    (window as any).trustedTypes.createPolicy('default', {
      createHTML: (string: string) => string,
      createScript: (string: string) => string,
      createScriptURL: (string: string) => string,
    });
  } catch (e) {
    console.warn('Failed to create default Trusted Types policy:', e);
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
